export default {
    products(state) {
        return state.products;
    },

    featured(state) {
        const featured = state.products.filter(p => p.is_featured === true);
        return featured;
    },

    latest(state) {
        const latests = state.products.filter(p => p.is_latest === true);
        return latests;
    },

    pair_features(state){
        let featured = state.products.filter(p => p.is_featured === true);
        let pairs = [];
            let i = 0;
            let a = 0
        featured.forEach(item => {
            if(i % 2 === 0){
                pairs[a] = [];
                pairs[a].push(item);
            }else{
                pairs[a].push(item);
                a++;
            }
            i++;
        });

        return pairs;
    },

    categories(state){
        return state.categories;
    },

    format_category(state){
        return state.format_category;
    },

    category_by_level(state, level){
        let categories = state.categories.filter((lvl) => lvl.categorylevel === level);
        return categories;
    },

    industrial_categories(state) {
        return state.industrial_category;
    },

    interchange_sku(state) {
        return state.interchange_sku;
    },
    interchange_manufacturers(state) {
        return state.interchange_manufacturers;
    },


    whi_smart_url(state) {
        return state.whi_smart_url;
    },

    whi_product(state) {
        return state.whi_product;
    },

    custom_attrs(state) {
        return state.custom_attrs;
    },

    filter_attr(state){
        return state.filter_attr;
    },
}